var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no_data"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/empty_icon.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('rechargeAndTransfer.no_data')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd9d65b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData.vue
// module id = null
// module chunks = 